export default __webpack_public_path__ + "static/media/postgreSQL.89fde3de.png";